export const isProbabilityValid = (probability: number): boolean => {
  return probability >= 0 && probability <= 1
}
